import React from 'react';
import CommunityTeamLineup from '../community/TeamLineup';

// Escalação do admin Futezap. Reusa o componente da comunidade em mode="admin":
//  - carrega jogadores de /organizer-players (tabela players do customer ativo)
//  - salva/carrega escalações com owner_type='customer', owner_id=customer_id
// Mesma UI/UX/CRUD, mesmo backend /api/lineups.
export default function OrganizerTeamLineup() {
  return <CommunityTeamLineup mode="admin" />;
}
